import { useEffect, useState } from "react";
import Cal, { getCalApi } from "@calcom/embed-react";
import { CalendarCheck } from "lucide-react";
import { getSchedulerConfig, recordBooking } from "../lib/api";

export const Scheduler = ({ lead, onBooked }) => {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getSchedulerConfig().then(setConfig).catch(() => setError("Could not load the scheduler."));
  }, []);

  useEffect(() => {
    if (!config?.configured) return;
    const swallow = (e) => {
      // Cal.com's embed script raises an opaque cross-origin "Script error"; it is not actionable.
      if (!e.message || e.message === "Script error.") e.stopImmediatePropagation();
    };
    window.addEventListener("error", swallow);
    (async () => {
      const cal = await getCalApi();
      cal("ui", { hideEventTypeDetails: false, layout: "month_view", theme: "dark" });
      cal("on", {
        action: "bookingSuccessful",
        callback: (e) => {
          const booking = e?.detail?.data?.booking || {};
          if (lead?.id) recordBooking(lead.id, { uid: booking.uid, start_time: booking.startTime }).catch(() => {});
          onBooked(booking);
        },
      });
    })();
    return () => window.removeEventListener("error", swallow);
  }, [config, lead?.id, onBooked]);

  if (error) return <p className="text-sm text-red-400" data-testid="scheduler-error">{error}</p>;
  if (!config) return <p className="font-mono-tech text-[11px] text-zinc-500">Loading scheduler…</p>;

  if (!config.configured) {
    return (
      <div className="border border-dashed border-zinc-800 bg-zinc-900/40 p-8 rounded-xl" data-testid="scheduler-unconfigured">
        <p className="flex items-center gap-2 font-mono-tech text-[11px] text-brand-pink"><CalendarCheck className="h-4 w-4" /> Scheduling not available yet</p>
        <p className="mt-3 text-sm leading-relaxed text-zinc-400">
          Your application is saved. The Sabrea team will reach out with times directly.
        </p>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-xl border border-zinc-800 bg-zinc-900/40" data-testid="scheduler-embed">
      <Cal
        calLink={config.cal_link}
        config={{
          name: lead.answers?.full_name || lead.artist_name || "",
          email: lead.answers?.email || "",
          notes: `Interested in: ${(lead.summary?.interests || []).join(", ")}`,
          "metadata[applicantId]": String(lead.id),
          layout: "month_view",
          theme: "dark",
        }}
        style={{ width: "100%", height: "680px", overflow: "scroll" }}
      />
    </div>
  );
};
